import { StyledRow } from "App/global-style";
import { Checkbox, CheckboxProps } from "Components/Form/Checkbox";
import React from "react";
import { StyledCheckbox } from "../../ProductPrice/AdviceCards/styled";
import { AkaAdviceCheckboxes } from "./interfaces";

interface Props {
  insuranceId: AkaAdviceCheckboxes;
  insuranceType: string;
  onChange?: CheckboxProps["onChange"];
}

export const AdviceCardHeader = ({
  insuranceId,
  insuranceType,
  onChange,
}: Props): React.ReactElement => {
  return (
    <StyledRow className="AdviceCardHeader">
      <StyledCheckbox className="InsuranceCheckbox">
        <Checkbox
          id={insuranceId}
          name={insuranceId}
          label={insuranceType}
          onChange={onChange}
        />
      </StyledCheckbox>
    </StyledRow>
  );
};
